import React from "react";
import ListPage from "./components/ListPage";
import { ContentCard } from "./components/ui";
import { mediaUrl } from "./utils/api";
import { formatDate } from "./utils/time";

/** Blog has no audience columns yet, so it is fully public — but the server only ever
 *  serves status='published'. Drafts and scheduled posts never leave the database. */
const BlogList = () => (
    <ListPage
        eyebrow="Knowledge"
        title="The Dolluz Corp Blog"
        intro="Engineering notes, architecture decisions and product stories from the people building our applications."
        endpoint="/api/Dolluzcorp/blog/posts"
        empty={{
            icon: "📝",
            title: "No posts published yet",
            message: "The team hasn't published anything yet. Check back soon.",
            noun: "post",
            nounPlural: "posts",
        }}
        renderCard={(b) => (
            <ContentCard
                key={b.id}
                to={`/blog/${b.id}`}
                kind={b.category_name || "Blog"}
                title={b.title}
                teaser={b.excerpt}
                meta={formatDate(b.published_at)}
                footer="Read post"
                /* thumb is a RELATIVE dAdmin media path, so it goes through mediaUrl like
                   every other uploaded file. null src → the card's placeholder. */
                image={{ src: b.thumb ? mediaUrl(b.thumb) : null }}
            />
        )}
    />
);

export default BlogList;
